import { BaseSettings, BaseThemeType } from 'Shared/frontend/themes/BaseSettings';
import { merge } from 'Shared/frontend/merge';
import { DeepPartial } from 'Shared/frontend/SettingsProvider';
import { NunitoSans } from 'Shared/frontend/fonts/NunitoSans';
import { Imbue } from 'Shared/frontend/fonts/Imbue';


export class DarlingNikkisSettings extends BaseSettings
{

	palette()
	{
		return {
			background: '#f6e9d2',
			text: '#503014',
			feature: '#cf1413', //red

			/* Eg the mobile nav colour */
			dimBackground: '#FDFAE7',

			food: '', 
			drinks: '',
			
			// CJ added: needed to change scrollBar colors for light theme
			scrollBar: {
				scrollbarColor: '#fdfae7 #f6e9d2 !important',
			}
		};
	}

	fontIncludes()
	{
		return[
			NunitoSans,
			Imbue
		];
	}

	fonts() {
		return {
			text: '"Nunito Sans", sans-serif',
			teaser: '"Imbue", serif',
			heading: '"Imbue", serif',
			tagline: '"Nunito Sans", sans-serif',
			buttons: '"Nunito Sans", sans-serif',
			desktopNav: '"Nunito Sans", sans-serif',
	mobileNav: '"Nunito Sans", sans-serif',
			subNav: '"Nunito Sans", sans-serif',
		};
	}

	
	poster()
	{
		return merge(super.poster(), {
			shared: {
				dateBar: {
					color: this.palette().feature,
					background: this.palette().background,
				},
			},
		});
	}

	page()
	{
		return merge(super.page(), {
			heading: {
				color: this.palette().feature,
			},
			section: {
				heading: {
					color: this.palette().feature,
					fontWeight: '500',
					fontSize:'clamp(1.3rem, 5vw, 4rem)!important',
					letterSpacing: 2.2, 
				},
				teaser:{
					color: this.palette().feature,
					fontFamily: this.fonts().teaser,
					fontWeight: '500',
					fontSize:'clamp(1.2rem, 5vw, 3rem)!important',	
				},
				tagline:{
					color: this.palette().feature,
					fontFamily: this.fonts().tagline,
					fontWeight: '300 !important',
					fontSize:'clamp(1.2rem, 5vw, 2rem)!important',	
				},
			},

			widgets: {
				subNav: {
					button: {
						backgroundColor: this.palette().text
					}
				},
			},

			button: {
				backgroundColor: this.palette().feature,
				borderRadius: '0.4em',
			},
		});
	}


	siteTheme()
	{
		const base = super.siteTheme();
		const palette = this.palette();

		const settings = merge(base, <DeepPartial<BaseThemeType>>{
			event: {
				artist: {
					heading: {
						color: palette.feature,
						fontFamily: 'sans-serif'
					},
					wide: {
						nameAndTime: {
							color: palette.feature
						}
					},
					narrow: {
						nameAndTime: {
							backgroundColor: palette.feature
						}
					}, 
					genresAndLocation: {
						color: palette.feature
					} 
				}
			},

	//TODO share most of this with the townie. eg 'ColouredDarkTheme' parent
	menu: {
		subNav: {
			button: {
				color: palette.feature,
				border: 'solid 3px',
				borderColor: palette.feature,
			},
			buttonType: type => ({ backgroundColor: palette.background })
		},
		section: {
			marginBottom: '3em'
		},
		item: {
			type: 'imageless',
			title: { 
			//	fontFamily: fonts.menuItem,
				fontSize: '1.3em',
				fontWeight: 'bold'
			},
		},
	},

			subNavButton: {
				borderRadius: '0.4em'
			},
		});

		// XXX if we want to entirely remove or overwrite a base setting or two then do so here 
		return settings;
	}
}

